import { useState } from "react";

import { FontSizeContext } from "./context";

type FontSizeProviderProps = {
  children: React.ReactNode;
};

export const FontSizeProvider: React.FC<FontSizeProviderProps> = ({
  children,
}) => {
  const [baseFontSize, setBaseFontSize] = useState<number>(16);

  return (
    <FontSizeContext.Provider value={{ baseFontSize, setBaseFontSize }}>
      {children}
    </FontSizeContext.Provider>
  );
};
